import { CHIPS_COLORS } from './colors';
import { ChipType } from '../types';

export const CHIPS_MIN_5: ChipType[] = [
  {
    color: CHIPS_COLORS.BLUE,
    value: 5,
  },
  {
    color: CHIPS_COLORS.YELLOW,
    value: 10,
  },
  {
    color: CHIPS_COLORS.RED,
    value: 20,
  },
  {
    color: CHIPS_COLORS.VIOLET,
    value: 50,
  },
  {
    color: CHIPS_COLORS.GREEN,
    value: 100,
  },
  {
    color: CHIPS_COLORS.ORANGE,
    value: 500,
  },
  {
    color: CHIPS_COLORS.LIGHT_BLUE,
    value: 1e3,
  },
  {
    color: CHIPS_COLORS.SCARLET,
    value: 2e3,
  },
  {
    color: CHIPS_COLORS.PURPLE,
    value: 5e3,
  },
  {
    color: CHIPS_COLORS.LIGHT_GREEN,
    value: 10e3,
  },
  {
    color: CHIPS_COLORS.PINK,
    value: 50e3,
  },
];
